import AntIcon from "@ant-design/icons"
import cx from "clsx"
import PropTypes from "prop-types"
import chroma from "chroma-js"
import { Tooltip, SkeletonWrapper } from ".."
import * as ReactIcons from "../../icons"
import * as LocalIcons from "../../svg"
import styles from "./index.module.less"

function Icon({
  icon,
  size = "1.2em",
  className,
  hasBackground,
  tooltipText,
  iconContainerStyle,
  flip,
  placement = "top",
  color,
  background,
  square,
  loading = false,
  ...rest
}) {
  const Component = ReactIcons[icon] || LocalIcons[icon]

  const styleVars = {
    "--icon-color": color,
    ...(hasBackground && {
      "--icon-bg-color": background || (color ? chroma.mix(color, "#fff", 0.85).hex() : undefined),
    }),
  }

  const getIcon = () =>
    tooltipText ? (
      <Tooltip placement={placement} title={tooltipText}>
        <AntIcon
          className={cx(styles.icon, className)}
          component={() => (Component ? <Component size={size} color={color} {...rest} /> : null)}
        />
      </Tooltip>
    ) : (
      <AntIcon
        className={cx(styles.icon, className)}
        component={() => (Component ? <Component size={size} color={color} {...rest} /> : null)}
      />
    )

  const iconContent = hasBackground ? (
    <div className={cx(styles.iconStyled, square && styles.square)} style={{ ...styleVars, ...iconContainerStyle }}>
      {getIcon()}
    </div>
  ) : (
    <div style={styleVars}>{getIcon()}</div>
  )

  return (
    <SkeletonWrapper 
      loading={loading} 
      width={size} 
      height={size} 
      round 
    >
      {iconContent}
    </SkeletonWrapper>
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  background: PropTypes.string,
  hasBackground: PropTypes.bool,
  loading: PropTypes.bool,
}

Icon.defaultProps = {
  loading: false,
}

export default Icon
